import deprecate from './deprecate';
import findAndReplaceSchemaUnderscores from './findAndReplaceSchemaUnderscores';

const parseLocation = (string, internalName) => {
  if (!string) return null;
  return string.replace(/\((LOCATION)\)/g, internalName);
};

const parseProviderName = (string, internalName) => {
  if (!string) return null;
  return string.replace(/\((Provider_Name)\)/g, internalName);
};

const parseProviderPhoneNumber = (string, internalName) => {
  if (!string) return null;
  return string.replace(/Provider_Phone_Number/g, internalName);
};

export {
  deprecate, parseLocation, findAndReplaceSchemaUnderscores,
  parseProviderName, parseProviderPhoneNumber,
};
